export const FunnelIcon = ({
  width,
  height,
  className,
}: {
  width?: number | string
  height?: number | string
  className?: string
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M16.214 3.483a1.112 1.112 0 0 0-1.026-.67H2.812a1.125 1.125 0 0 0-.83 1.881l.006.006L6.75 9.785v5.402a1.125 1.125 0 0 0 1.749.937l2.25-1.5a1.124 1.124 0 0 0 .501-.937V9.785L16.013 4.7l.006-.006a1.111 1.111 0 0 0 .195-1.211ZM10.278 9.18a.562.562 0 0 0-.153.382v4.124l-2.25 1.5V9.564a.563.563 0 0 0-.152-.385l-4.91-5.24h12.374L10.279 9.18Z"
      />
    </svg>
  )
}
